
import { Injectable } from '@angular/core';
import { LoadFormConfigurationStateFail, FormConfigurationActionTypes, SaveFormConfigurationSuccess, SaveFormConfiguration } from './form-configuration.actions';
import { IFormConfiguration, LGEDataService } from '../../../commons';
import { LoadFormConfigState } from '../../login/state/login.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

@Injectable()
export class FormConfigurationEffects {

  saveFormConfiguration$ = createEffect(
    () => this.actions$.pipe(
      ofType(FormConfigurationActionTypes.SaveFormConfiguration),
      map((action: SaveFormConfiguration) => action.payload),
      switchMap((config) => this.lge.FormConfigsIUD(config)),
      switchMap((state: IFormConfiguration) =>
        [new SaveFormConfigurationSuccess(), new LoadFormConfigState()]),
      catchError(error => of(new LoadFormConfigurationStateFail(error)))
    )
  )

  constructor(
    private actions$: Actions,
    private lge: LGEDataService
  ) { }
}